// extracted by mini-css-extract-plugin
export default {"container":"logo_container__x1LAD","soloLogo":"logo_soloLogo__SvXOT","hideLogo":"logo_hideLogo__0zUht"};